// *** This MobileHeader should be phased out in favour of using ./expander-header/index.tsx directly ***
import React from 'react';

import createReactClass from 'create-react-class';

export default createReactClass({
  displayName: 'mobile-header',

  getInitialState() {
    return { expanded: this.props.expanded };
  },

  getDefaultProps() {
    return {
      titleStyle: {},
      title: '',
      expanded: false,
      titleAsExpander: false,
      expander: true,
      bodyStyle: {},
      style: {}
    };
  },

  toggle() {
    return this.setState({ expanded: !this.state.expanded }, this.props.onToggle);
  },

  render() {
    const titleStyle = Object.assign({}, this.props.titleStyle, {
      cursor: 'pointer',
      position: 'relative'
    });
    const bodyStyle = Object.assign({}, this.props.bodyStyle, {
      overflow: 'hidden',
      width: '100%',
      maxHeight: this.state.expanded ? window.innerHeight + 250 : 0,
      transition: 'all 0.5s ease-out'
    });
    bodyStyle.display = this.state.expanded ? 'block' : 'none';

    return (
      <div className="mobile-header" style={this.props.style}>
        <div style={titleStyle} onClick={this.props.titleAsExpander ? this.toggle : function () {}}>
          <div style={{ display: 'inline-block' }}>{this.props.title}</div>
          {this.props.expander ? (
            <div
              style={{
                display: 'inline-block',
                position: 'absolute',
                right: 0
              }}
            >
              {this.state.expanded ? (
                <i
                  onClick={this.toggle}
                  className="fa fa-chevron-up float-right"
                  style={{ padding: 8, fontSize: 18 }}
                />
              ) : (
                <i
                  onClick={this.toggle}
                  className="fa fa-chevron-down float-right"
                  style={{ padding: 8, fontSize: 18 }}
                />
              )}
            </div>
          ) : undefined}
        </div>
        <div style={bodyStyle}>{this.props.children}</div>
      </div>
    );
  }
});
